import { nullOrNumber } from '@proprioo/hokkaido';

import { useSquadsByAgentId } from './useSquadsByAgentId';

export const useAgentsByAgentId = (agentId?: nullOrNumber) => {
  const squads = useSquadsByAgentId(agentId);

  return squads?.flatMap(squad => squad.agents) || [];
};
